import { defineMessages } from 'react-intl';

export default defineMessages({
    premium: {
        id: 'ml.gateway.pa.quotesticky.premium',
        defaultMessage: 'PREMIUM'
    },
    month: {
        id: 'ml.gateway.pa.quotesticky.month',
        defaultMessage: 'month'
    }
});